// // src/index.js - Updated exports with merchant filtering functions
// // Import styles first
// import './styles.css';

// // Export wallet service utilities and constants
// export {
//   connectWallet,
//   sendTransaction,
//   detectWallets,
//   getSupportedWalletsForNetwork,
//   getWalletInstallUrl,
//   NETWORK_TYPES,
//   WALLET_TYPES,
//   TOKEN_CONFIG,
//   NETWORK_CONFIG
// } from './services/walletService';

// // Export API functions (Updated with new merchant filtering functions)
// export {
//   createPayment,
//   getPayment,
//   processPayment,
//   getSupportedNetworks,
//   getMerchantWallets,
//   getMerchantFeePercentage,
//   getMerchantNetworks, // New export for merchant's configured networks
//   getMerchantTokens, // New export for merchant's supported tokens
//   isMerchantNetworkSupported, // New export to check network support
//   isMerchantTokenSupported, // New export to check token support
//   validateWalletAddress,
//   generateMockTransactionHash
// } from './services/api';

// // Export context providers
// export { ThemeProvider } from './context/ThemeContext';
// export { CoinleyProvider, useCoinley } from './context/CoinleyContext';

// // Export components
// export { default as QRCode } from './components/QRCode';
// export { default as PaymentStatus } from './components/PaymentStatus';
// export { default as PaymentMethods } from './components/PaymentMethods';
// export { default as CoinleyModal } from './components/CoinleyModal';
// export { default as CoinleyCheckout } from './components/CoinleyCheckout';

// // Export constants
// export const DEFAULT_CONFIG = {
//   apiUrl: 'https://coinleyserver-production.up.railway.app',
//   debug: false,
//   testMode: false,
//   theme: 'light',
//   supportedNetworks: ['ethereum', 'bsc', 'tron', 'algorand']
// };








// src/index.js - Updated with new networks support
// Import styles first
import './styles.css';

// Export wallet service utilities and constants - Updated with new networks
export {
  // Modern wallet core hooks and components
  useWallet,
  useWalletConnect,
  useWalletTransaction,
  useWalletDetection,
  useTokenBalance,
  useNetworkSwitch,
  useWalletSign,
  useWalletSignTypedData,
  useWalletModal,
  ConnectButton,
  WalletModal,
  CoinleyWalletProvider,
  initializeWalletCore,
  getWalletConfig,
  // Compatibility functions (legacy + modern hybrid)
  connectWallet,
  sendTransaction,
  detectWallets,
  getSupportedWalletsForNetwork,
  getWalletInstallUrl,
  disconnectWallet,
  isEvmNetwork,
  // Constants
  NETWORK_TYPES,
  WALLET_TYPES,
  TOKEN_CONFIG,
  NETWORK_CONFIG,
  NETWORK_WALLET_MAP
} from './services/walletCoreService';

// Legacy wallet service exports (for backward compatibility)
export {
  debugWalletEnvironment,
  getTokenConfig,
  validateWalletAddress,
  generateMockTransactionHash,
  detectWalletsWithRetry,
  sendTokenTransaction,
  sendERC20Transaction,
  sendNativeTransaction
} from './services/walletService';

// Export API functions
export {
  createPayment,
  getPayment,
  processPayment,
  verifyQRPayment,
  getSupportedNetworks,
  getMerchantWallets,
  getMerchantFeePercentage,
  getMerchantNetworks,
  getMerchantTokens,
  isMerchantNetworkSupported,
  isMerchantTokenSupported,
  initializeApi,
  getApiConfig
} from './services/api';

// Export context providers
export { ThemeProvider } from './context/ThemeContext';
export { CoinleyProvider, useCoinley } from './context/CoinleyContext';

// Export components
export { default as QRCode } from './components/QRCode';
export { default as PaymentStatus } from './components/PaymentStatus';
export { default as PaymentMethods } from './components/PaymentMethods';
export { default as CoinleyModal } from './components/CoinleyModal';
export { default as CoinleyCheckout } from './components/CoinleyCheckout';

// Export icon components
export {
  EthIcon,
  TronIcon,
  AlgorandIcon,
  SolanaIcon,
  BscIcon,
  PyusdIcon,
  UsdpIcon
} from './components/icons';

// ✅ UPDATED: Enhanced default config with new networks
export const DEFAULT_CONFIG = {
  apiUrl: 'http://localhost:9000',
  debug: false,
  testMode: false,
  theme: 'light',
  // ✅ UPDATED: Include all supported networks
  supportedNetworks: [
    'ethereum', 
    'bsc', 
    'tron', 
    'algorand', 
    'solana',
    'optimism',
    'arbitrum', 
    'polygon', 
    'avalanche', 
    'celo'
  ]
};

// Version info
export const VERSION = '1.4.0'; // Updated version for new networks

// Main initialization function
export const initializeCoinley = async (config) => {
  const { initializeApi } = await import('./services/api');
  return initializeApi(config);
};

// ✅ NEW: Network utilities export
export const SUPPORTED_NETWORKS = {
  ETHEREUM: 'ethereum',
  BSC: 'bsc',
  TRON: 'tron',
  ALGORAND: 'algorand',
  SOLANA: 'solana',
  OPTIMISM: 'optimism',
  ARBITRUM: 'arbitrum',
  POLYGON: 'polygon',
  AVALANCHE: 'avalanche',
  CELO: 'celo'
};

// ✅ NEW: Helper functions for new networks
export const getNetworkDisplayName = (networkShortName) => {
  const names = {
    ethereum: 'Ethereum',
    bsc: 'Binance Smart Chain',
    tron: 'TRON',
    algorand: 'Algorand',
    solana: 'Solana',
    optimism: 'Optimism',
    arbitrum: 'Arbitrum One',
    polygon: 'Polygon',
    avalanche: 'Avalanche',
    celo: 'Celo'
  };
  return names[networkShortName] || networkShortName;
};

export const isEVMNetwork = (networkShortName) => {
  const evmNetworks = [
    'ethereum', 
    'bsc', 
    'optimism', 
    'arbitrum', 
    'polygon', 
    'avalanche', 
    'celo'
  ];
  return evmNetworks.includes(networkShortName.toLowerCase());
};

export const getNetworkChainId = (networkShortName) => {
  const chainIds = {
    ethereum: 1,
    bsc: 56,
    optimism: 10,
    arbitrum: 42161,
    polygon: 137,
    avalanche: 43114,
    celo: 42220
  };
  return chainIds[networkShortName.toLowerCase()];
};

// ✅ NEW: Network icon mapping (you can add actual icon components later)
export const getNetworkIcon = (networkShortName) => {
  // This would return actual icon components in a real implementation
  const icons = {
    ethereum: '⟨ETH⟩',
    bsc: '⟨BSC⟩',
    tron: '⟨TRX⟩',
    algorand: '⟨ALGO⟩',
    solana: '⟨SOL⟩',
    optimism: '⟨OP⟩',
    arbitrum: '⟨ARB⟩',
    polygon: '⟨MATIC⟩',
    avalanche: '⟨AVAX⟩',
    celo: '⟨CELO⟩'
  };
  return icons[networkShortName.toLowerCase()] || '⟨?⟩';
};